// extracted by mini-css-extract-plugin
module.exports = {"CurrentBalance":"CurrentBalance_rn4Co"};